// extracted by mini-css-extract-plugin
export default {"action_buttons":"customers_action_buttons__UdsQx","org_owner":"customers_org_owner__DZGWa","users":"customers_users__gdO6F","back_title":"customers_back_title__houuC"};